import type { SupabaseProjectStatus, SupabaseRegion } from '~/types/supabase';

export const mapStatusToDisplayStatus: Record<SupabaseProjectStatus, string> = {
  ACTIVE_HEALTHY: 'active',
  ACTIVE_UNHEALTHY: 'active (unhealthy)',
  COMING_UP: 'coming up',
  GOING_DOWN: 'going down',
  INACTIVE: 'paused',
  INIT_FAILED: 'init failed',
  REMOVED: 'removed',
  RESTARTING: 'restarting',
  UNKNOWN: 'unknown',
  UPGRADING: 'upgrading',
  PAUSING: 'pausing',
  RESTORING: 'restoring',
  RESTORE_FAILED: 'restore failed',
  PAUSE_FAILED: 'pause failed',
  RESIZING: 'resizing',
};

type SupabaseRegionCountryCode =
  | 'us'
  | 'ca'
  | 'ie'
  | 'gb'
  | 'fr'
  | 'de'
  | 'ch'
  | 'se'
  | 'in'
  | 'sg'
  | 'jp'
  | 'kr'
  | 'au'
  | 'br';

export const availableRegions: {
  id: SupabaseRegion;
  name: string;
  countryCode: SupabaseRegionCountryCode;
}[] = [
  {
    id: 'us-west-1',
    name: 'West US (North California)',
    countryCode: 'us',
  },
  {
    id: 'us-east-1',
    name: 'East US (North Virginia)',
    countryCode: 'us',
  },
  {
    id: 'us-east-2',
    name: 'East US (Ohio)',
    countryCode: 'us',
  },
  {
    id: 'ca-central-1',
    name: 'Canada (Central)',
    countryCode: 'ca',
  },
  {
    id: 'eu-west-1',
    name: 'West EU (Ireland)',
    countryCode: 'ie',
  },
  {
    id: 'eu-west-2',
    name: 'West Europe (London)',
    countryCode: 'gb',
  },
  {
    id: 'eu-west-3',
    name: 'West EU (Paris)',
    countryCode: 'fr',
  },
  {
    id: 'eu-central-1',
    name: 'Central EU (Frankfurt)',
    countryCode: 'de',
  },
  {
    id: 'eu-central-2',
    name: 'Central Europe (Zurich)',
    countryCode: 'ch',
  },
  {
    id: 'eu-north-1',
    name: 'North EU (Stockholm)',
    countryCode: 'se',
  },
  {
    id: 'ap-south-1',
    name: 'South Asia (Mumbai)',
    countryCode: 'in',
  },
  {
    id: 'ap-southeast-1',
    name: 'Southeast Asia (Singapore)',
    countryCode: 'sg',
  },
  {
    id: 'ap-northeast-1',
    name: 'Northeast Asia (Tokyo)',
    countryCode: 'jp',
  },
  {
    id: 'ap-northeast-2',
    name: 'Northeast Asia (Seoul)',
    countryCode: 'kr',
  },
  {
    id: 'ap-southeast-2',
    name: 'Oceania (Sydney)',
    countryCode: 'au',
  },
  {
    id: 'sa-east-1',
    name: 'South America (São Paulo)',
    countryCode: 'br',
  },
];
